import elementClosest from 'element-closest';
elementClosest(window);
